import { Container } from 'inversify'
import { interpret } from 'xstate-v4'
import { rootContainer } from '~/container'
import { HowDidYouHearAboutUsFetch } from './HowDidYouHearAboutUsFetch'
import {
  HowDidYouHearAboutUsMachineInterpreter,
  returnHowDidYouHearAboutUsMachine,
} from './machine'

export const howDidYouHearAboutUsContainer = new Container()
howDidYouHearAboutUsContainer.parent = rootContainer

howDidYouHearAboutUsContainer
  .bind<HowDidYouHearAboutUsMachineInterpreter>('HowDidYouHearAboutUsMachine')
  .toDynamicValue((ctx) =>
    interpret(
      returnHowDidYouHearAboutUsMachine().withConfig({
        services: {
          submitAnswer: ({ answer }, { signature }) => {
            return new HowDidYouHearAboutUsFetch().submit(signature, answer)
          },
        },
      }),
    ),
  )
